import React from "react";

const NimbusTitle = ({ isLarge = false }) => {
  let textSize = "text-3xl";
  if (isLarge) {
    textSize = "text-6xl";
  }

  return (
    <div
      className={`flex flex-col gap-2 ${textSize} font-black text-color-dark-text-primary`}
    >
      Nimbus.
    </div>
  );
};

export default NimbusTitle;
